// NOTE. No @nab packages in front.
import type * as nabUtils from '@nab/utils';
type NabUtils = typeof nabUtils;

export function getElementLabel( selector: string ): string {
	const parent = window.parent;
	return hasNabUtils( parent )
		? parent.nab.utils.getElementLabel( selector )
		: 'Element';
}

const hasNabUtils = (
	win: unknown
): win is {
	readonly nab: {
		readonly utils: NabUtils;
	};
} =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	!! ( win as any )?.nab?.utils;
